import React from 'react';

const ExtendIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" },
    className
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.33073 4.66669H3.9974C3.64377 4.66669 3.30464 4.80716 3.05459 5.05721C2.80454 5.30726 2.66406 5.6464 2.66406 6.00002V12C2.66406 12.3536 2.80454 12.6928 3.05459 12.9428C3.30464 13.1929 3.64377 13.3334 3.9974 13.3334H9.9974C10.351 13.3334 10.6902 13.1929 10.9402 12.9428C11.1903 12.6928 11.3307 12.3536 11.3307 12V8.66669M6.66406 9.33335L13.3307 2.66669M13.3307 2.66669H9.9974M13.3307 2.66669V6.00002",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
ExtendIcon.displayName = "Icons.ExtendIcon";

export { ExtendIcon };
//# sourceMappingURL=ExtendIcon.js.map
